import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Hourglass } from "lucide-react";

export const TrackerDepositCard = ({ job }) => {
  const [bank, setBank] = useState(null);
  const d = job.deposit;
  useEffect(() => {
    if (d && !d.received_at) api.get("/settings/payment").then((r) => setBank(r.data)).catch(() => {});
  }, [d]);
  if (!d || d.received_at || job.status === "Cancelled") return null;

  return (
    <div className="rounded-md p-5 sm:p-6 bg-spark-yellow text-spark-ink" data-testid="tracker-deposit-card">
      <div className="flex items-start gap-4">
        <div className="size-12 rounded-full flex items-center justify-center shrink-0 bg-spark-ink/10"><Hourglass className="size-6" /></div>
        <div className="flex-1 min-w-0">
          <p className="label-mono">Awaiting deposit to proceed ({d.pct}%)</p>
          <p className="font-display uppercase tracking-tight text-4xl font-bold mt-0.5" data-testid="tracker-deposit-amount">${Number(d.amount).toFixed(2)}</p>
          <p className="text-xs mt-1.5 opacity-80">
            {d.pct}% of the ${Number(d.quote_total).toFixed(2)} quote, needed before we order special-order parts. Balance due on completion. Due by <strong>{d.due_date}</strong>.
          </p>
          {bank?.bank_account_number && (
            <p className="text-sm mt-3" data-testid="tracker-deposit-bank">
              Bank transfer to <strong>{bank.bank_account_name}</strong> · <strong className="font-mono">{bank.bank_account_number}</strong> · reference <strong>{job.ref_number}</strong>
            </p>
          )}
          <p className="text-[11px] mt-2 opacity-70">Deposits are handled as set out in Section 3 of our <Link to="/terms" className="underline">Terms and Conditions</Link>.</p>
        </div>
      </div>
    </div>
  );
};
